import API from './API.js'

export default class Apology extends API {
  constructor() {
    super('apology')
  }
}
